import { useTranslation } from 'react-i18next';

export default function ContentSections() {
  const { t } = useTranslation();

  return (
    <>
      <section id="about" className="bg-background-100 py-14 md:py-20 scroll-mt-20 md:scroll-mt-24">
        <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10 items-start">
            <div className="lg:col-span-4">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-information-line text-sm" aria-hidden="true"></i>
                </span>
                USFans Spreadsheet
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold tracking-tight text-foreground-950">
                {t('about.title')}
              </h2>
            </div>
            <div className="lg:col-span-8 space-y-4">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{t('about.p1')}</p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{t('about.p2')}</p>
            </div>
          </div>
        </div>
      </section>

      <section id="review" className="bg-background-50 py-14 md:py-20 scroll-mt-20 md:scroll-mt-24">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            <div id="shipping" className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8 scroll-mt-20 md:scroll-mt-24">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-truck-line text-2xl" aria-hidden="true"></i>
              </div>
              <h2 className="mt-5 font-heading text-xl md:text-2xl font-bold tracking-tight text-foreground-950">
                {t('shipping.title')}
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">{t('shipping.p1')}</p>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">{t('shipping.p2')}</p>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className="ri-star-line text-2xl" aria-hidden="true"></i>
              </div>
              <h2 className="mt-5 font-heading text-xl md:text-2xl font-bold tracking-tight text-foreground-950">
                {t('review.title')}
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">{t('review.p1')}</p>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">{t('review.p2')}</p>
            </div>
          </div>
        </div>
      </section>

      <section id="safety" className="bg-background-100 py-14 md:py-20 scroll-mt-20 md:scroll-mt-24">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10 items-start">
              <div className="lg:col-span-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-200 text-secondary-700">
                  <i className="ri-shield-check-line text-2xl" aria-hidden="true"></i>
                </div>
                <h2 className="mt-5 font-heading text-xl md:text-2xl font-bold tracking-tight text-foreground-950">
                  {t('safety.title')}
                </h2>
              </div>
              <div className="lg:col-span-8 space-y-4">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{t('safety.p1')}</p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{t('safety.p2')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}